<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import SiteCreate from '../../sites/components/SiteCreate.vue'

// Not ready for release: organisation creation is only open in development builds
definePage({
    meta: {
        devOnly: true,
        requiresAuth: true,
        requiresOrganisation: false,
        hideHeader: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <SiteCreate />
</template>